module.exports = __webpack_public_path__ + "static/media/img-default.817312ba.png";